import { hideChatAndFastTrack } from "../../lib/featureFlags";
import type { AgentRunMode } from "../api/e2e";

export default function RunTrackIndicator({ mode }: { mode: AgentRunMode }) {
  if (hideChatAndFastTrack() || mode !== "fast_track") return null;

  return (
    <span
      className="agent-run-track agent-run-track--fast"
      aria-label="Fast track"
      title="Fast track"
    >
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M9.4 1 3.8 8.6h3.4L6.6 15l5.6-8.1H8.8L9.4 1Z" />
      </svg>
    </span>
  );
}
